import {
    CHECK_PERMISSION_REQUEST_SUCCESS,
    CHECK_PERMISSION_FOR_VIEW_REQUEST,
    CHECK_PERMISSION_FOR_VIEW_REQUEST_SUCCESS,
    CHECK_PERMISSION_FOR_FIELD_REQUEST,
    CHECK_PERMISSION_FOR_FIELD_REQUEST_SUCCESS,
} from '../constants/check_last_route_and_permission.constants';

export const checkPermissionRequestSuccess = payload => ({
    type: CHECK_PERMISSION_REQUEST_SUCCESS, payload,
});

export const checkPermissionForViewRequest = urls => ({ type: CHECK_PERMISSION_FOR_VIEW_REQUEST, urls });
export const checkPermissionForViewRequestSuccess = payload => ({ type: CHECK_PERMISSION_FOR_VIEW_REQUEST_SUCCESS, payload });

export const checkPermissionForFieldRequest = urls => ({ type: CHECK_PERMISSION_FOR_FIELD_REQUEST, urls });
export const checkPermissionForFieldRequestSuccess = payload => ({ type: CHECK_PERMISSION_FOR_FIELD_REQUEST_SUCCESS, payload });



// WEBPACK FOOTER //
// ./src/modules/App/redux/actions/check_permission.actions.js